import { useP2GInView } from '@parcel2go/core-ui';
import { useEffect, useState } from 'react';

interface props {
  inview: (iv: boolean) => void;
  timeout: number;
  triggerOnce: boolean;
  children?: React.ReactNode;
}

const SmartSendInViewCheck: React.FC<props> = (props) => {
  const [ref, inView] = useP2GInView({
    triggerOnce: props.triggerOnce
  });
  const [itsBeenLongEnough, setItsBeenLongEnough] = useState(false);

  useEffect(() => {
    const timer1 = setTimeout(() => {
      setItsBeenLongEnough(inView);
    }, props.timeout);
    return () => {
      clearTimeout(timer1);
    };
  }, [inView]);

  useEffect(() => {
    if (itsBeenLongEnough) {
      props.inview(true);
    }
  }, [itsBeenLongEnough]);

  return <div ref={ref}>{props.children}</div>;
};

export default SmartSendInViewCheck;
